<template>
  <div class="contest-detail">
    <div class="boxes">
      <contest-mini
        class="boxed"
        :class="{'white-theme': !contest.is_template}"
        :contest="contest"></contest-mini>
    </div>
    <h5 class="top-space bottom-space" v-if="canEdit">Admin</h5>
    <div class="boxes" v-if="canEdit">
      <div class="boxed light contest-info">
        <div class="boxes compact width30" v-if="contest.requires_join_code">
          <div>
            <div class="highlight">{{join_code}}</div>
            <label>Join Code</label>
          </div>
        </div>
        <div class="boxes compact width30">
          <div v-if="contest.for_season_key">
            <div>{{contest.for_season_key}}</div>
            <label>Season</label>
          </div>
          <div v-if="contest.for_format">
            <div>{{contest.for_format | capitalise}}</div>
            <label>Format</label>
          </div>
          <div v-if="contest.matches_after">
            <div>{{contest.matches_after | simpleDate}}
              &amp; {{contest.matches_before | simpleDate}}
            </div>
            <label>Between</label>
          </div>
        </div>
        <div class="boxes compact width30">
          <div v-if="contest.created_by">
            <div><small>{{contest.created_by.name}}</small></div>
            <label>Created by</label>
          </div>
        </div>
        <div class="tools-line">
          <router-link
            class="box-button border"
            :to="{name:'cricketFantasyContest', params:{key:contest.key}}">
            Edit</router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ContestMini  from '@/components/cricket/fantasy/ContestMini'

export default {
  props: {
    contest: Object,
    canEdit: Boolean
  },
  components: {
    'ContestMini': ContestMini
  },
}
</script>
